<template>
  <div class="details">
    <template v-if="hasData">
      <div class="sec-block1">
        <div class="title">
          题目描述
        </div>
        <div class="abs-btn">
          <div class="btn-txt" @click="hanldeShowDialog" v-if="answerStatus !== '3' && !isErr && !isColl">查看结果</div>
          <div class="case-num">
            <span class="num-col">{{ curTopic && curTopic.curIndex }}</span>
            /{{ topicList && topicList.length }}
          </div>
        </div>
        <van-swipe ref="vantSwiper" @change="onChange" :touchable="false" :show-indicators="false" :loop="false">
          <van-swipe-item v-for="(item, index) in topicList" :key="index">
            <div class="div-txt">{{ dayDetails && dayDetails.questionTitle }}</div>
            <div class="div-imgs">
              <div class="imgs" :style="`background-image: url(${questionImage.url})`" @click="handleClickImgs">
                <img :src="questionImage && questionImage.url" style="visibility: hidden;" class="imgs img-block" alt="">
              </div>
              <div v-if="questionVideo && Object.keys(questionVideo).length > 0" class="imgs"
                :style="`background-image: url(${questionVideo.url})`" @click="handleClickQuesion">
                <img :src="questionVideo && questionVideo.url" style="visibility: hidden;" class="imgs img-block" alt="">
                <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
              </div>
            </div>
            <div class="sec-block2">
              <div class="title">
                选择答案({{ dayDetails.questionType === '1' ? '单选题' : '多选题' }})
              </div>
              <div class="change-list">
                <div class="item-txt" v-for="(item, index) in dayDetails.questionOptions"
                  :class="itemIds.includes(item.id) ? 'cur' : ''" :key="index" @click="handleClickItems(item)">
                  <img src="@/assets/images/questionBank/img(23).png" v-if="itemIds.includes(item.id)" class="item-icon"
                    alt="">
                  <img src="@/assets/images/questionBank/img(25).png" v-else class="item-icon" alt="">
                  {{ item && item.optionContent }}
                </div>
              </div>
            </div>
            <div class="wrapper"
              v-if="(answerStatus === '3' || isErr || isColl || dayDetails.isUserAnswer) && userAnswer && userAnswer.length > 0"
              @click.stop>
              <div class="wrapper-con">
                <div class="answer-txt true" v-if="userAnswer.length > 0 && answerIsTrue === 'true'">回答正确</div>
                <div class="answer-txt" v-if="userAnswer.length > 0 && answerIsTrue === 'false'">回答错误</div>
                <div class="true-tip-block" v-if="userAnswer.length > 0">
                  <div class="true-txt1">
                    <span class="label">答案：</span>
                    {{ trueTxt }}
                  </div>
                  <div class="true-txt1 true-txt2" v-if="dayDetails && dayDetails.remark">
                    <span class="label">临床结论：</span>
                    {{ dayDetails.remark }}
                  </div>
                  <div class="true-txt1" v-if="analysisVideo && Object.keys(analysisVideo).length > 0">
                    视频解析:
                    <div class="video-div" @click="handlePlayVideo">
                      <img src="@/assets/images/home/bg_question1@2x.png" class="video-cover" alt="">
                    </div>
                  </div>
                  <div class="true-txt1"
                    v-if="(questionCourses && questionCourses.length > 0) || (questionDocuments && questionDocuments.length > 0) || (questionCases && questionCases.length > 0)">
                    <span class="span-txt">本题知识点来源:</span>
                    <div class="right-con">
                      <div v-if="questionCourses.length > 0">
                        <div class="right-txt" v-for="(item, index) in questionCourses"
                          @click="handleDialogUnlock('course', item)" :key="index">
                          <span class="tag-txt">课程</span>
                          <div class="title-txt">
                            <img v-if="`${item.isUnlock}` === '1' && !item.myUnlock"
                              src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                            {{ item && item.courseName }}
                          </div>
                          <!-- <div class="title-txt">{{ item && item.courseName }}</div> -->
                          <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                        </div>
                      </div>
                      <div v-if="questionCases.length > 0">
                        <div class="right-txt" @click="handleDialogUnlock('case', item)"
                          v-for="(item, index) in questionCases" :key="index">
                          <span class="tag-txt">病例</span>
                          <div class="title-txt">{{ item && item.caseDetail.title }}</div>
                          <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                        </div>
                      </div>
                      <div v-if="questionDocuments.length > 0">
                        <div class="right-txt" @click="handleDialogUnlock('document', item)"
                          v-for="(item, index) in questionDocuments" :key="index">
                          <span class="tag-txt">文献</span>
                          <div class="title-txt">{{ item && item.documentDetail.title }}</div>
                          <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="div-block-tips">该部分内容由专家提供，仅代表专家个人观点。供医疗卫生专业人士学术交流目的使用，仅供参考。临床的具体情况请以专业人士的临床诊断为准。</div>
                </div>
                <!-- <div class="wrapper-btn" v-if="userAnswer.length <= 0" @click="handleSubmit">确认答案</div> -->
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="fix-btn">
        <div class="btn-txt"
          v-if="answerStatus !== '3' && !isErr && !isColl && !showConfirmBtn && !dayDetails.isUserAnswer"
          @click="handleSubmit">确认答案</div>
        <div class="flex-btn">
          <div class="btn-item" @click="handlePrevTopic">
            <img src="@/assets/images/questionBank/img(9).png" class="item-icon" alt="">
            <div class="item-txt">上一题</div>
          </div>
          <div class="btn-item" @click="handleCollect">
            <img v-if="isCollect" src="@/assets/images/questionBank/img(8).png" class="item-icon" alt="">
            <img v-else src="../../assets/images/questionBank/img(16).png" class="item-icon" alt="">
            <div class="item-txt">收藏</div>
          </div>
          <div class="btn-item" @click="isFeedBack = true">
            <img src="@/assets/images/questionBank/img(15).png" class="item-icon" alt="">
            <div class="item-txt">纠错</div>
          </div>
          <div class="btn-item" @click="handleNextTopic">
            <img src="@/assets/images/questionBank/img(17).png" class="item-icon" alt="">
            <div class="item-txt">下一题</div>
          </div>
        </div>
      </div>
      <div class="div-dialog" v-if="showAll">
        <div class="div-bg"></div>
        <div class="div-content">
          <div class="dialog-title">
            <div class="title-block">
              <img src="@/assets/images/questionBank/img(23).png" class="block-icon" alt="">
              已通过
            </div>
            <div class="title-block">
              <div class="block-icon title-icon"></div>
              <!-- <img src="@/assets/images/questionBank/img(25).png" class="block-icon" alt=""> -->
              未通过/未答题
            </div>
            <img src="@/assets/images/questionBank/no-passed-close-btn.png" @click="showAll = false" class="close-img"
              alt="">
          </div>
          <div class="flex-list">
            <div class="items-btn" :class="item.answerStatus + '' === '3' ? 'cur' : ''"
              v-for="(item, index) in topicList" :key="index" @click="handleClickTopic(index, 'click')">{{ index + 1 }}
            </div>
          </div>
          <div class="dialog-btn" @click.stop="handleClickSubmit">提交并查看结果</div>
        </div>
      </div>
      <div class="dialog-video" v-if="videoDialog">
        <div class="dialog-video-bg" @click.stop="handlePauseVideo"></div>
        <VideoPlayerAnswer ref="video" :playerVideo="analysisVideo"></VideoPlayerAnswer>
      </div>
      <van-overlay :show="isFeedBack" @click="isFeedBack = false">
        <div class="wrap" @click.stop>
          <div class="wrap-txt">纠错反馈</div>
          <div class="wrap-con">
            <van-field v-model="feedModel" rows="2" autosize type="textarea" maxlength="200" placeholder="请输入您的反馈..."
              show-word-limit />
          </div>
          <div class="warp-btn">
            <div class="btn btn1" @click="isFeedBack = false">取消</div>
            <div class="btn btn2" @click="handleFeedBack('feedback')">提交反馈</div>
          </div>
        </div>
      </van-overlay>
      <van-overlay :show="showImage" class="loading-overlay">
        <van-loading type="spinner" />
      </van-overlay>
      <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleClick" :dataProps="dataProps"></dialog-unlock>
    </template>
    <template v-else>
      <van-loading type="spinner" />
    </template>
  </div>
</template>
<script>
import { getQuestion, postDaily, postCollect, delCollect, getWrongStat, getCollectStat, getQuestionList, getQuestionUserStatus, getUnlock, getIsCorrect } from '../../api/questionBank'
import { sendFeedback } from '@/api/api'
import { ImagePreview } from 'vant'
import {setSha, stopScroll, canScroll, traceClickURL, throttle} from '../../utils/util'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer.vue'
import { getShareInfo } from '@/utils/wxShare'
import dialogUnlock from '@/components/dialogUnlock.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce } from 'lodash-es'
import {isScorm} from '../../api/scorm'

const UserProfile = {
  components: {
    VideoPlayerAnswer,
    dialogUnlock
  },
  data () {
    return {
      dayDetails: {},
      questionImage: {},
      questionVideo: {},
      showAll: false,
      questionOptions: [],
      itemIds: [],
      topicList: [],
      curTopic: {},
      curSwiperIndex: 0,
      isCollect: false,
      answerStatus: 1,
      // 知识来源课程
      questionCourses: [],
      // 知识来源文献
      questionDocuments: [],
      // 知识来源病例
      questionCases: [],
      // 解析视频
      analysisVideo: {},
      trueTxt: '',
      answerIsTrue: '',
      videoDialog: false,
      isFeedBack: false,
      feedModel: '',
      userAnswer: [],
      isErr: false,
      isColl: false,
      showImage: false,
      showConfirmBtn: false,
      isAnswerBool: false,
      dataDetails: {},
      typeTxt: '',
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
      hasData: false,
      trueAnswerId: [],
      isFeedbackSubmitting: false
    }
  },
  mounted () {
    this.questionId = this.$route.query.questionId
    this.isErr = this.$route.query.isErr
    this.isColl = this.$route.query.isColl
    this.classCode = this.$route.query.classCode
    this.difficultyLevel = this.$route.query.difficultyLevel
    let params = {
      classCode: this.classCode,
      difficultyLevel: this.difficultyLevel,
      iepUserId: this.userInfo.id
    }
    canScroll()
    if (!this.isColl && !this.isErr) {
      getUnlock(params).then(res => {
        if (!res.data) {
          this.$router.push({
            path: '/disease'
          })
        } else {
          getQuestionUserStatus({
            userId: this.userInfo.id,
            questionId: this.questionId
          }).then(res => {
            this.hasData = true
            this.answerStatus = `${res.data}`
            this.handleFun()
          })
        }
      })
    } else {
      this.hasData = true
      this.answerStatus = this.$route.query.answerStatus
      this.handleFun()
    }
    window.vueThis = this
  },
  beforeDestroy () {
    sessionStorage.removeItem('video-track-cache')
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    // 反馈操作
    handleFeedBack: throttle(function(type) {
      if (this.isFeedbackSubmitting) {
        return
      }
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      if (!this.feedModel) {
        this.$toast('请先输入内容再提交！')
        return
      }
      this.isFeedbackSubmitting = true
      let content = ''
      if (type === 'feedback') {
        content = this.feedModel
      }
      let params = {
        type: 3,
        baseId: this.dayDetails.id,
        baseTitle: `${this.dayDetails.questionClassEntity ? this.dayDetails.questionClassEntity.className : ''}-LV${this.dayDetails.difficultyLevel}-${this.dayDetails.questionNumber}`,
        content,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      const loading = this.$toast({
        message: '提交中...',
        forbidClick: true
      })
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.$toast('反馈成功')
        } else {
          this.$toast(res.msg)
        }
      }).finally(() => {
        loading.clear()
        this.isFeedBack = false
        this.isFeedbackSubmitting = false
      })
    }, 500),
    handleClickSubmit () {
      this.$router.push({
        path: `/questionResult?classCode=${this.classCode}&difficultyLevel=${this.difficultyLevel}`
      })
    },
    // 如果分享为空或者没有内容的
    handleSetArrOnce () {
      let params = {}
      if (this.dayDetails) {
        params = {
          classCode: this.classCode,
          className: this.dayDetails.questionClassEntity.className,
          collectTime: '1723616408000',
          difficultyLevel: this.dayDetails.difficultyLevel,
          questionId: this.questionId,
          questionNumber: this.dayDetails.questionNumber,
          questionTitle: this.dayDetails.questionTitle,
          questionType: '2',
          serialNumber: 1,
        }
      }
      return [params]
    },
    handleUpdateTopicNum () {
      if (this.isErr) {
        getWrongStat({
          classCode: this.classCode,
          difficultyLevel: this.difficultyLevel
        }).then(res => {
          let dataprams = res.data.filter((item) => item.questionId === this.questionId)
          this.topicList = dataprams && dataprams.length > 0 ? res.data : this.handleSetArrOnce()
          this.topicList.map((item, index) => {
            if (item.questionId + '' === this.questionId) {
              item.curIndex = index + 1
              this.$refs.vantSwiper.swipeTo(index)
              this.curTopic = item
            }
          })
        })
      } else if (this.isColl) {
        getCollectStat({
          classCode: this.classCode,
          difficultyLevel: this.difficultyLevel
        }).then(res => {
          let dataprams = res.data.filter((item) => item.questionId === this.questionId)
          this.topicList = dataprams && dataprams.length > 0 ? res.data : this.handleSetArrOnce()
          this.topicList.map((item, index) => {
            if (item.questionId + '' === this.questionId) {
              item.curIndex = index + 1
              this.$refs.vantSwiper.swipeTo(index)
              this.curTopic = item
            }
          })
        })
      } else {
        this.topicList.map((item, index) => {
          if (item.id === this.questionId) {
            item.curIndex = index + 1
            this.$refs.vantSwiper.swipeTo(index)
            this.curTopic = item
          }
        })
      }
    },
    // 题目序列表点击跳转到对应的题目
    handleClickTopic (index, type) {
      if (index + 1 === this.curTopic.curIndex) return
      this.dayDetails = {}
      this.questionImage = {}
      this.questionVideo = {}
      this.itemIds = []
      this.questionOptions = []
      this.$refs.vantSwiper.swipeTo(index)
    },
    // 显示题目序列号
    hanldeShowDialog () {
      this.showAll = !this.showAll
      this.handleUpdateTopicNum()
    },
    // 收藏
    handleCollect () {
      let params = {
        'userId': this.userInfo.id,
        'questionId': this.questionId
      }
      if (this.isCollect) {
        let params1 = {
          'classCode': this.classCode,
          'difficultyLevel': this.difficultyLevel
        }
        delCollect(Object.assign(params, params1)).then(res => {
          this.$toast('取消收藏')
          this.isCollect = false
        })
      } else {
        postCollect(params).then(res => {
          this.$toast('收藏成功')
          this.isCollect = true
          this.isCollect = true
        })
      }
    },
    // 上一题
    handlePrevTopic: debounce(function () {
      let prevIndex = this.curTopic.curIndex - 2
      if (prevIndex < 0) {
        this.$toast('这里是第一题！')
        return
      }
      this.userAnswer = []
      this.handleClickTopic(prevIndex)
    }, 500),
    // 下一题
    handleNextTopic: debounce(function() {
      let nextIndex = this.curTopic.curIndex
      if (nextIndex === this.topicList.length) {
        this.$toast('您已到最后一题！')
        return
      }
      this.userAnswer = []
      this.handleClickTopic(nextIndex)
    }, 500),
    onChange (e) {
      this.curSwiperIndex = e
      this.topicList[this.curSwiperIndex].curIndex = e + 1
      this.curTopic = this.topicList[this.curSwiperIndex]
      if (!this.isColl && !this.isErr) {
        this.questionId = this.topicList[this.curSwiperIndex].id
        this.dayDetails = this.topicList[this.curSwiperIndex]
        this.handelGetDetails()
      } else {
        this.questionId = this.topicList[this.curSwiperIndex].questionId
        this.handleFun()
      }
    },
    handleSubmit: debounce(function() {
      if (this.itemIds.length === 0) {
        this.$toast('作题答案不能为空！')
        return
      }
      if (this.dayDetails.questionType === '2' && this.itemIds.length < 2) {
        this.$toast('该题为多选题，请至少选择两个选项！')
        return
      }
      this.handleSubmitCon()
    }, 500),
    async handleSubmitCon () {
      let itemIdsSort = this.itemIds && this.itemIds.length > 0 ? this.itemIds.sort() : this.itemIds
      let params = {
        'classCode': this.classCode,
        'difficultyLevel': this.difficultyLevel,
        'questionId': this.questionId,
        'iepUserId': this.userInfo.id,
        'optionIds': itemIdsSort
      }
      try {
        const res = await postDaily(params)
        if (res.data.unlockRemind) {
          this.$toast(`您已经解锁${this.dayDetails.questionClassEntity.className}level${this.difficultyLevel},下面可以开始level${Number(this.difficultyLevel) + 1}的学习`)
        }
        this.$set(this.dayDetails, 'isUserAnswer', true)
        this.answerIsTrue = ''
        await this.getAnswerIsTrue()
        if (this.answerIsTrue === 'true') {
          this.topicList[this.curSwiperIndex].answerStatus = '3'
        }
      } catch (err) {
        this.$toast(err.msg)
      }
    },
    async getAnswerIsTrue() {
      try {
        const result = await getIsCorrect({
          userId: this.userInfo.id,
          questionId: this.questionId,
        })
        if (result.code === 0) {
          this.answerIsTrue = `${result.data}`
          return
        }
        this.answerIsTrue = ''
      } catch (e) {
      }
    },
    handleClickImgs () {
      this.showImage = true
      this.imgToBase64(this.questionImage.url).then(imgUrl => {
        this.showImage = false
        ImagePreview({
          images: [imgUrl],
          showIndex: false,
          closeable: true
        })
      })
    },
    handleClickQuesion () {
      this.setVideoTrackCache(this.dayDetails && this.dayDetails.id)
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.questionVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId = this.dayDetails.questionVideoId
        this.$refs.video.player.play() // 尝试再次执行播放
      })
    },
    handleClickItems (item) {
      if (this.isColl || this.isErr || this.answerStatus === '3' || this.dayDetails.isUserAnswer) return
      if (this.dayDetails.questionType === '1') {
        this.itemIds = [item.id]
        this.userAnswer = [item]
      } else {
        if (this.itemIds.includes(item.id)) {
          this.itemIds = this.itemIds.filter(res => res !== item.id)
          this.userAnswer = this.userAnswer.filter(res => res.id !== item.id)
        } else {
          this.itemIds.push(item.id)
          this.userAnswer.push(item)
        }
      }
      this.topicList[this.curSwiperIndex].userAnswer = this.userAnswer
    },
    handleFun () {
      if (!this.isColl && !this.isErr) {
        let params = {
          classCode: this.classCode,
          difficultyLevel: this.difficultyLevel,
          type: this.answerStatus === '3' ? 1 : 2
        }
        getQuestionList(params).then(res => {
          this.topicList = res.data
          this.dayDetails = this.topicList.filter(item => item.id === this.questionId)[0]
          this.handelGetDetails()
        })
      } else {
        getQuestion({ questionId: this.questionId }).then(res => {
          this.dayDetails = res.data
          this.handelGetDetails()
        })
      }
    },
    async handelGetDetails () {
      if (!this.dayDetails) {
        this.$toast('暂无题目返回')
        return
      }
      window.sessionStorage.setItem('mainId', this.dayDetails.id)
      this.setVideoTrackCache()
      let link = ''
      let linkTimeLine = ''
      if (this.isColl || this.isErr) {
        link = window.location.href + `&classCode=${this.dayDetails.questionClass}&difficultyLevel=${this.dayDetails.difficultyLevel}&${(this.isErr || this.isColl) ? 'shareColl=true' : 'bankShare=true'}`
        linkTimeLine = window.location.href + `&classCode=${this.dayDetails.questionClass}&difficultyLevel=${this.dayDetails.difficultyLevel}&${(this.isErr || this.isColl) ? 'shareColl=true' : 'bankShare=true'}`
      } else {
        link = window.location.href
        linkTimeLine = window.location.href
      }
      getShareInfo({
        title: 'iEP-心电图分类题库',
        titleTimeLine: 'iEP-海量心电图分类题库，进阶心电王者',
        desc: '解锁更多题目，进阶心电王者',
        link: link, // modifyURLParam(link, 'entrance', '33'),
        linkTimeLine: linkTimeLine, // modifyURLParam(linkTimeLine, 'entrance', '34'),
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
      this.answerStatus = `${this.dayDetails.answerStatus}`
      if (this.dayDetails.difficultyLevel && this.dayDetails.questionClass) {
        this.classCode = this.dayDetails.questionClass
        this.difficultyLevel = this.dayDetails.difficultyLevel
        this.handleUpdateTopicNum()
      }
      this.isCollect = this.dayDetails.isCollect
      if (this.dayDetails.answerStatus + '' === '3' || this.isColl || this.isErr || this.dayDetails.isUserAnswer) {
        this.userAnswer = this.dayDetails.userAnswer
        if (this.userAnswer && this.userAnswer.length > 0) {
          this.itemIds = this.userAnswer.map(item => item.questionOption ? item.questionOption.id : item.id).sort()
        }
      }
      this.questionOptions = this.dayDetails.questionOptions.map(item => {
        item.isCheck = false
        return item
      })
      this.answerIsTrue = ''
      if (this.userAnswer && this.userAnswer.length > 0) {
        // 判断回答是否正确
        await this.getAnswerIsTrue()
      }
      if (this.dayDetails.questionImage) {
        this.questionImage = this.dayDetails.questionImage
      }
      if (this.dayDetails.questionVideo) {
        this.questionVideo = this.dayDetails.questionVideo
      }
      // 获取正确答案得id
      this.trueAnswerIdArr = this.dayDetails.questionAnswers.map(item => item.optionAnswer)
      this.trueAnswerId = this.trueAnswerIdArr.map(item => item.id).sort()
      // 获取正确答案的txt
      this.trueTxt = this.dayDetails.questionAnswers.map(item => item.optionAnswer.optionContent).toString()
      this.questionCourses = this.dayDetails.questionCourses && this.dayDetails.questionCourses.length > 0 ? this.dayDetails.questionCourses : []
      this.questionDocuments = this.dayDetails.questionDocuments && this.dayDetails.questionDocuments.length > 0 ? this.dayDetails.questionDocuments : []
      this.questionCases = this.dayDetails.questionCases && this.dayDetails.questionCases.length > 0 ? this.dayDetails.questionCases : []
      this.analysisVideo = this.dayDetails.analysisVideo ? this.dayDetails.analysisVideo : {}
    },
    handleDialogUnlock (type, item) {
      this.dataDetails = item
      this.typeTxt = type
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.courseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleClick()
    },
    // 跳转知识点来源
    async handleClick () {
      let item = this.dataDetails
      let type = this.typeTxt
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=8&businessChannel=8&campId=${this.dayDetails.journeyId || ''}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (type === 'course') {
        window.sessionStorage.setItem('entrance', '8')
        const query = {
          courseId: item.courseId,
          journeyId: this.dayDetails.journeyId,
          businessId: this.dayDetails.journeyId,
          entrance: '8',
          channel: '8'
        }
        const isscorm = await isScorm(item.courseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      } else if (type === 'case') {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.caseId}${openidBindli}&id=${item.caseId}${trackParams}`
      } else if (type === 'document') {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.documentId,
            journeyId: this.dayDetails.journeyId,
            businessId: this.dayDetails.journeyId,
            entrance: '8',
            channel: '8'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.documentId}${openid}${iepTxt}${trackParams}`
      }
    },
    // 播放视频
    handlePlayVideo () {
      this.setVideoTrackCache(this.dayDetails && this.dayDetails.id)
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.analysisVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId = this.dayDetails.analysisVideo.id
        this.$refs.video.player.play() // 尝试再次执行播放
      })
      // this.videoDialog = true
      // stopScroll()
      // this.$nextTick(() => {
      //   this.$refs.video.player.play() // 尝试再次执行播放
      // })
    },
    // 暂停视频
    handlePauseVideo () {
      this.resetVideoTraceSession()
      this.videoDialog = false
      canScroll()
      this.$refs.video.player.pause() // 尝试再次执行播放
    },
    resetVideoTraceSession () {
      if (this.videoDialog && this.$refs.video && this.$refs.video.handleVideoTrace) {
        this.$refs.video.handleVideoTrace(this.$refs.video.curVideoPlayer)
      }
      sessionStorage.removeItem('curPlaySessionVideo')
      sessionStorage.removeItem('videoSectionId')
      sessionStorage.removeItem('videoTraceId')
    },
    setVideoTrackCache (questionId) {
      const entrance = this.$route.query.entrance || window.sessionStorage.getItem('entrance') || ''
      const channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : this.$route.query.channel || ''
      const campId = questionId || this.questionId || (this.dayDetails && this.dayDetails.id) || ''
      sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance,
        campId,
        channel
      }))
    },
    imgToBase64 (url) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = url
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = () => {
          // 获取最后一个.的位置
          var index = url.lastIndexOf('.')
          // 获取后缀
          var ext = url.substr(index + 1).toLowerCase()

          const canvas = document.createElement('canvas')
          canvas.width = image.naturalWidth // 使用 naturalWidth 为了保证图片的清晰度
          canvas.height = image.naturalHeight
          canvas.style.width = `${canvas.width / window.devicePixelRatio}px`
          canvas.style.height = `${canvas.height / window.devicePixelRatio}px`
          const ctx = canvas.getContext('2d')
          if (!ctx) {
            return null
          }
          ctx.drawImage(image, 0, 0)

          ctx.font = '50px Arial' // 设置字体大小和字体
          ctx.rotate(-0.2) // 设置文字旋转角度
          ctx.globalAlpha = 0.2
          // 创建实体水印
          ctx.fillStyle = '#545454' // 颜色
          ctx.textAlign = 'left'
          ctx.textBaseline = 'Middle'

          for (var x = -800; x <= 3200; x += 400) {
            for (var y = -1200; y <= 6000; y += 300) {
              var text = 'iEP-心电图答题'
              for (var i = 1; this.getTrueLength(text) > 0; i++) {
                var tl = this.cutString(text, 10)
                ctx.fillText(text.substr(0, tl).replace(/^\s+|\s+$/, ''), x, i * 60 + y)
                // ctx.strokeText(text.substr(0, tl).replace(/^\s+|\s+$/, ""), x, i * 100 + y);
                text = text.substr(tl)
              }
            }
          }

          const base64 = canvas.toDataURL('image/' + ext)

          return resolve(base64)
        }
        image.onerror = (err) => {
          return reject(err)
        }
      })
    },
    getTrueLength (str) { // 获取字符串的真实长度（字节长度）
      let len = str.length
      let truelen = 0
      for (var x = 0; x < len; x++) {
        if (str.charCodeAt(x) > 128) {
          truelen += 2
        } else {
          truelen += 1
        }
      }
      return truelen
    },
    cutString (str, leng) { // 按字节长度截取字符串，返回substr截取位置
      let len = str.length
      let tlen = len
      let nlen = 0
      for (var x = 0; x < len; x++) {
        if (str.charCodeAt(x) > 128) {
          if (nlen + 2 < leng) {
            nlen += 2
          } else {
            tlen = x
            break
          }
        } else {
          if (nlen + 1 < leng) {
            nlen += 1
          } else {
            tlen = x
            break
          }
        }
      }
      return tlen
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.details {
  position: relative;
  background-color: #fff;
  padding: 15px;
  padding-bottom: 110px;
  box-sizing: border-box;

  .title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding-left: 8px;
    box-sizing: border-box;
    line-height: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      position: absolute;
      width: 4px;
      left: 0;
      top: 4px;
      height: 12px;
      border-radius: 100px;
      background-color: #EB1700;
      content: '';
    }
  }

  .abs-btn {
    position: absolute;
    right: 20px;
    top: 15px;
    display: flex;
    align-items: center;

    .btn-txt {
      width: 68px;
      height: 24px;
      border-radius: 30px;
      background-color: #EB1700;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 24px;
      margin-right: 16px;
    }

    .case-num {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #333333;

      .num-col {
        color: #EB1700;
      }
    }
  }

  .div-txt {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
  }

  .div-imgs {
    margin-bottom: 16px;

    .imgs {
      width: 100%;
      display: block;
      margin-top: 10px;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;

      .img-block {
        pointer-events: none;
      }
    }

    .icon-play {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .change-list {
    .item-txt {
      width: 100%;
      margin-bottom: 13px;
      background-color: #F5F5F5;
      border-radius: 20px;
      font-size: 14px;
      color: #333333;
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      &.cur {
        color: #EB1700;
      }

      .item-icon {
        width: 17px;
        height: 17px;
        display: block;
        margin-right: 12px;
      }
    }
  }

  .fix-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #F1F1F1;
    padding: 8px 10px;
    box-sizing: border-box;
    width: 100vw;
    z-index: 9;

    .btn-txt {
      width: 100%;
      height: 40px;
      text-align: center;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 40px;
      background-color: #EB1700;
      border-radius: 100px;
      margin-bottom: 18px;
    }

    .flex-btn {
      display: flex;
      align-items: center;

      .btn-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item-icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-bottom: 4px;
        }

        .item-txt {
          font-size: 14px;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }

  .div-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9;

    .div-bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .div-content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 56vh;
      background-color: #fff;
      box-shadow: 1px 4px 11px rgba(0, 0, 0, 0.25);
      border-radius: 24px 24px 0 0;
    }

    .dialog-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.3);
      height: 20px;
      padding: 0 25px;
      padding-top: 20px;
      padding-bottom: 16px;
      position: relative;

      .title-block {
        display: flex;
        align-items: center;
      }

      .close-img {
        width: 12px;
        height: 12px;
        position: absolute;
        top: 24px;
        right: 30px;
      }

      .block-icon {
        width: 16px;
        height: 16px;
        margin: 0 8px;

        &.title-icon {
          background-color: rgba(0, 0, 0, .08);
          border-radius: 50%;
        }
      }
    }

    .flex-list {
      max-height: calc(56vh - 125px);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      padding: 0 25px;
      box-sizing: border-box;

      .items-btn {
        width: 40px;
        height: 40px;
        margin-right: 17px;
        margin-bottom: 16px;
        background-color: rgba(24, 24, 24, 0.08);
        font-size: 16px;
        color: rgba(0, 0, 0, 0.3);
        font-weight: bold;
        text-align: center;
        line-height: 40px;
        border-radius: 50%;

        &:nth-child(6n) {
          margin-right: 0;
        }

        &.cur {
          background-color: #EB1700;
          color: #fff;
        }
      }
    }

    .dialog-btn {
      width: 355px;
      height: 40px;
      border-radius: 100px;
      background-color: #EB1700;
      position: absolute;
      left: 10px;
      bottom: 15px;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
}

.wrapper {
  z-index: 9;
  bottom: 0;
  background-color: #fff;
  padding-top: 0;

  .title-bar-view {
    padding-top: 24px;
    padding-bottom: 15px;
    position: sticky;
    top: 0;
    background-color: #fff;
    margin-bottom: 0;
    box-sizing: border-box;
    z-index: 9;
  }

  .wrapper-con {
    box-sizing: border-box;
  }

  .change-list {
    .item-txt {
      width: 100%;
      margin-bottom: 13px;
      background-color: #F5F5F5;
      border-radius: 20px;
      font-size: 14px;
      color: #333333;
      padding: 10px 20px;
      box-sizing: border-box;

      &.cur {
        background-color: #EB1700;
        color: #FFFFFF;
      }
    }
  }

  .answer-txt {
    font-size: 14px;
    color: #EB1700;
    text-align: center;

    &.true {
      color: #328714;
    }
  }

  .wrapper-btn {
    width: 352px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    background-color: #EB1700;
    border-radius: 100px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .true-tip-block {
    background-color: #F5F6F8;
    padding: 10px 16px;
    box-sizing: border-box;
    margin-top: 16px;

    .true-txt1 {
      font-size: 14px;
      color: #6A7481;
      font-weight: 500;
      margin-bottom: 16px;
      line-height: 20px;
      display: flex;
      flex-wrap: wrap;

      &.true-txt2 {
        max-height: 140px;
        overflow-y: auto;
      }

      .label {
        font-size: 14px;
        color: #313235;
        font-weight: 600;
      }

      .span-txt {
        width: 100%;
        display: block;
        color: #313235;
        font-weight: 600;
      }

      .right-con {
        width: 100%;

        .right-txt {
          display: flex;
          align-items: center;
          width: 100%;
          height: 38px;
          margin-top: 8px;
          background: rgba(255, 91, 12, 0.08);
          justify-content: space-between;
          padding-left: 12px;
          padding-right: 8px;
          box-sizing: border-box;
          border-radius: 4px;

          .tag-txt {
            width: 30px;
            height: 16px;
            border-radius: 4px;
            background-color: #EB1700;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            color: #FFFFFF;
          }

          .title-txt {
            font-size: 14px;
            color: #EB1700;
            width: 220px;
            white-space: nowrap;
            overflow: hidden;
            display: flex;
            align-items: center;
            text-overflow: ellipsis;

            .icon-unlock {
              width: 10px;
              margin-right: 4px;
              display: block;
            }
          }

          .icon-more {
            width: 16px;
            height: 16px;
            display: block;
          }
        }
      }

      .video-div {
        position: relative;
        width: 137px;
        height: 72px;
        display: block;
        margin-left: 20px;

        .video-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .icon-play {
          width: 23px;
          height: 23px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .div-block-tips {
    margin-left: 50%;
    transform: translateX(-50%);
    background-color: #EDEEF5;
    border-radius: 4px;
    color: #6A7481;
    font-size: 10px;
    line-height: 20px;
    width: 100%;
    margin-top: 18px;
    padding: 10px 12px;
    box-sizing: border-box;
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
/deep/ .van-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}</style>

<style scoped>
.dialog-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.dialog-video-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .6);
}

.player {
  position: relative;
  width: 100%;
  height: 200px;
  top: 50%;
  margin-top: -50%;
  z-index: 99999;
}

.player.isFullPlayer {
  position: static;
  height: auto;
  top: 0;
  margin-top: 0;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/questionDetails.vue